<template>
  <div id="app">
    <header  class="netland-color">
      <div class="website-title">
        <span class="logo" v-html="$ml.get('menu.title')"/>
        {{ $ml.get('menu.subtitle') }}
      </div>
      <b-navbar toggleable="md" type="dark">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse is-nav id="nav-collapse">
          <b-navbar-nav>
            <b-nav-item>
              <router-link class="netland-link" to="/">{{ $ml.get('menu.home') }}</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link class="netland-link" to="/features">{{ $ml.get('menu.features') }}</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link class="netland-link" to="/credits">{{ $ml.get('menu.credits') }}</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link class="netland-link" to="/contacts">{{ $ml.get('menu.contacts') }}</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link class="netland-link" to="/contents">{{ $ml.get('menu.contents') }}</router-link>
              </b-nav-item>
            <b-nav-item>
              <router-link class="netland-link" to="/opentracking">{{$ml.get('menu.opentracking')}}</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link class="netland-link" to="/demo">{{$ml.get('menu.demo')}}</router-link>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
    <main>
      <router-view></router-view>
      <b-button v-show="showGoTop" id="goTopBtn" @click="goTop()">Top</b-button>
    </main>
    <footer class="enlarged">
      <div v-html="$ml.get('appvue.footer_large')"/>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      user: null,
      slide: 0,
      sliding: true,
      enlargeFooter: true
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll (event) {
      this.showGoTop = document.body.scrollTop > 400 || document.documentElement.scrollTop > 400
    },
    goTop () {
      window.scroll({top: 0, behavior: 'smooth'})
    }
  }
}
</script>

<style>
html { overflow-x: hidden; }
@font-face {
  font-family: 'Nasalization';
  src: url('/static/fonts/NASALIZA.TTF');
}

body {
  margin: 0;
}

h1, h2, h3 { color: #3d4856; }

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #3d4856;
}

main {
  text-align: center;
  margin-top: 40px;
  font-family: 'Montserrat', sans-serif;
  margin-bottom: 20rem;
}

header {
  margin: 0;
  margin-bottom: 4em;
  color: #effaff;
  font-family: 'Montserrat', sans-serif;
}

footer {

  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #444;
  padding: .73em;
  padding-right: 4em;
  font-family: 'Montserrat', sans-serif;
}

footer p, footer span, footer div {
  float: right;
  text-align: right;
  color: #999;
  font-size: 0.7rem;
}

header span {
  display: block;
  position: relative;
  font-size: 20px;
  line-height: 1;
  letter-spacing: .02em;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 16px;
}

.navbar-brand span {
  font-family: nasalization;
}

.netland-color {
  padding-top: 15em!important;
  padding-bottom: 0.2em;
  background-image: url('/static/img/overlay_newtracking.png');
  /*background-color: #428bca;*/
  background-color: #0898DE;
  z-index: 999!important;
}

.navbar-dark .navbar-nav .nav-link {
  color: #FDFDFD!important;
}

.navbar-dark .navbar-nav .nav-link:hover {
  color: #e6f2ff!important;
}


.navbar-dark .navbar-nav .nav-link .netland-link {
  color: #FDFDFD!important;
}

.navbar-dark .navbar-nav .nav-link .netland-link:hover {
  color: #e6f2ff!important;
  text-decoration: none;
}

.navbar-dark .navbar-nav .nav-link .router-link-exact-active {
  background-color: #E0161A!important;
  padding: .7rem;
  border-radius: .3rem;
  color: #FDFDFD!important;
}

.navbar-dark .navbar-nav .nav-link .router-link-exact-active:hover {
  color: #e6f2ff!important;
  text-decoration: none;
  /*background-color: #444!important;*/
}

.btn-outline-primary {
  border-color: transparent!important;
  color: #FDFEFF!important;
}

.btn-outline-primary:hover {
  border-color: transparent!important;
  color: #e6f2ff!important;
}

.website-title {
  top: 2em;
  left: 2em;
  position: absolute;
}

.website-title .logo {
  font-family: Nasalization;
  font-size: 3em;
}

@media only screen and (max-width: 1000px) {
  .website-title .logo {
    font-family: Nasalization;
    font-size: 1.7em;
  }
}
.website-title .reg-mark {
  font-size: 1em;
}

.enlarged {
  height: 5rem!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue